import { api } from "../lib/api";

// TRAIN-4 · unmatched SMS queue + unreachable badges (/api/sms-admin/*).
// Admin/manager only; the backend enforces, this just carries.

export interface UnmatchedSms {
  id: string;
  from_phone: string;
  normalized_phone?: string | null;
  body: string;
  num_media: number;
  // PKT-0472 · "lead_match" = the phone matched ZERO clients and one or more
  // known LEADS. Not a stranger. The union must admit it: the backend can send
  // this value as of migration 069, and nothing validates this response at
  // runtime — TypeScript is the only contract there is, so a union that omits
  // it is a type that lies about the wire.
  reason: "no_match" | "ambiguous" | "lead_match";
  matched_client_ids?: string[] | null;
  matched_lead_ids?: string[] | null;
  created_at?: string | null;
}

export interface ResolveResult {
  resolved: boolean;
  thread_message_id?: string | null;
  consent_recorded?: string | null;
}

export async function listUnmatchedSms(): Promise<UnmatchedSms[]> {
  return api.get<UnmatchedSms[]>("/sms-admin/unmatched");
}

export async function resolveUnmatchedSms(
  rowId: string,
  clientId: string,
  confirmPhoneMismatch = false
): Promise<ResolveResult> {
  return api.post<ResolveResult>(`/sms-admin/unmatched/${rowId}/resolve`, {
    client_id: clientId,
    confirm_phone_mismatch: confirmPhoneMismatch,
  });
}

export async function dismissUnmatchedSms(rowId: string): Promise<ResolveResult> {
  return api.post<ResolveResult>(`/sms-admin/unmatched/${rowId}/dismiss`, {});
}

export async function fetchSmsUnreachableClientIds(): Promise<string[]> {
  const res = await api.get<{ client_ids: string[] }>(
    "/sms-admin/unreachable-clients"
  );
  return res.client_ids;
}
